import React, {useEffect, useState} from 'react'
import {BoardData} from "@/service/BoardService";
import BottomButton from "@/view/common/component/button/BottomButton";
import {USER_ID} from "@/common/Constant";

export interface BoardDetailParam {
    board: BoardData | undefined,
}

const BoardDetail = (props:BoardDetailParam) => {
    const [boardData, setBoardData] = useState(props.board)

    useEffect(()=>{
        setBoardData(props.board)
    }, [props])

    return <>
        <div className={'mt-24px'}>
            <div className={'w-100p h-min-50p'}>
                <div className={'s_title_1_m'}><p>{boardData?.title}</p></div>
                <div className={'c1_r cl-gray04'}><p>작성자 : {boardData?.writerNickName}</p></div>
                <div className={'c1_r cl-gray04'}><p>작성일시 : {boardData?.regDt}</p></div>
                <div className={'c1_r cl-gray04'}><p>마지막 수정일시 : {boardData?.updateDt}</p></div>
                <div className={'b2_r mt-32px'}><p className={'board-content'}>{boardData?.content}</p></div>
            </div>
            <div className={'border-top-gray mt-36px'}/>
        </div>
    </>
}

export default BoardDetail